// import { Component } from 'react';
// import React from 'react';
// import './Glosterblackstorm.css';
// import {
//   Box,
//   Typography,
// } from '@mui/material';
// import { Link } from 'react-router-dom';
// import Navbar from '../../../../Home/Components/Nav';
// import Footer from '../../../../Home/Components/Footer';
// import HeroPriceSection from "../../../../MgComet/Components/HeroPriceSection";
// // import Pricing from '../../Gloster Blackstorm/Components/CityPricing';
// import 'bootstrap/dist/css/bootstrap.min.css';
// class Hector extends Component {
   
//   render() {
//     return (
//       <div id='container'>
//         <Navbar />
//         {/* Banner */}
//         <div id="banner-image-glosterblack">
//           <HeroPriceSection
//           mainPrice="PRICE STARTS AT ₹ 43.35 LAKH*"
//           // mainPrice="₹9.99 LAKH + BATTERY RENTAL @ ₹3.9*/km"
//           buttonText="Download Brochure"
//           desktopBg="https://mgmotor.scene7.com/is/image/mgmotor/gr-bn-dsc-031?hei=2160&qlt=80&resMode=bisharp"
//           mobileBg="https://mgmotor.scene7.com/is/image/mgmotor/gr-bn-dsc-031-portrait?hei=1600&qlt=80&resMode=bisharp"
//           overlayWidth="55vw"   
//         />
//   {/* <div id="glost-left">
//     <Typography
//       variant="h4"
//       sx={{
//         color: 'white',
//         marginTop: '120px',
//         fontSize: '16px',
//         fontFamily: 'GillSansBold, sans-serif',
//         fontWeight: '700',
//       }}
//     >
//       PRICE STARTS AT ₹ 41.05 LAKH*
//     </Typography>
    
    
//   </div> */}
// </div>

// <div style={{height:'40px',width:'100%',marginTop:'8px'}}>
// <Link to="/" style={{ textDecoration: 'none', color: 'grey',cursor:'pointer' }}>
// &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;<b>Home</b> 
// </Link>
// <Link to="/Glosterblackstorm" style={{ textDecoration: 'none', color: 'grey',cursor:'pointer' }}>
//   &nbsp;&nbsp; &nbsp;&nbsp;MG Gloster BlackStorm
// </Link></div>
// <div id="part2"></div>
// <div id="part3"></div>
// <div id="part4"></div>
// <div id="part5"></div>

//        {/* Pricing Section */}
//         {/* <Pricing/> */}

//         <Footer />
//       </div>
//     );
//   }
// }

// export default Hector;




























import { Component } from 'react';
import React from 'react';
import './Glosterblackstorm.css';
import { Link } from 'react-router-dom';
import Navbar from '../../../../Home/Components/Nav';
import Footer from '../../../../Home/Components/Footer';
import HeroPriceSection from "../../../../MgComet/Components/HeroPriceSection";
import 'bootstrap/dist/css/bootstrap.min.css';

class Hector extends Component {
  render() {
    return (
      <div id='container'>
        <Navbar />

        {/* ── Banner ── */}
        <div id="banner-image-glosterblack">

          {/* Responsive image — browser picks portrait on mobile, landscape on desktop */}
          <picture id="banner-picture">
            <source
              media="(max-width: 768px)"
              srcSet="https://mgmotor.scene7.com/is/image/mgmotor/gr-bn-dsc-031-portrait?hei=1600&qlt=80&resMode=bisharp"
            />
            <img
              src="https://mgmotor.scene7.com/is/image/mgmotor/gr-bn-dsc-031?hei=2160&qlt=80&resMode=bisharp"
              alt="MG Gloster BlackStorm"
              id="banner-img"
            />
          </picture>

          {/* Overlay: price + button only — NO desktopBg/mobileBg props */}
          <div id="banner-overlay">
            <HeroPriceSection
              mainPrice="PRICE STARTS AT ₹ 43.35 LAKH*"
              buttonText="Download Brochure"
              overlayWidth="55vw"
            />
          </div>

        </div>

        {/* Breadcrumb */}
        <div style={{ height: '40px', width: '100%', marginTop: '8px' }}>
          <Link to="/" style={{ textDecoration: 'none', color: 'grey', cursor: 'pointer' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>Home</b>
          </Link>
          <Link to="/Glosterblackstorm" style={{ textDecoration: 'none', color: 'grey', cursor: 'pointer' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;MG Gloster BlackStorm
          </Link>
        </div>

        <div id="part2"></div>
        <div id="part3"></div>
        <div id="part4"></div>
        <div id="part5"></div>

        <Footer />
      </div>
    );
  }
}

export default Hector;